import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HlrCurrencies } from '@helpers/types/models';
import { UserService } from '../../../auth/user.service';
import { CurrenciesService } from './currencies.service';
import { 
	AlarisComplexTableComponent,
	AlarisDialogService,
	AlarisTableStateService,
	EditPanelWidth, 
	RowActionSimple, 
	TABLE_STATE_SERVICE_INJECTOR 
} from '@campaign-portal/components-library';
import { CurrenciesFieldsService } from './currencies-fields.service';
import { TableSettingsService } from '@helpers/api/table-settings.service';
import { TableTypes } from '@campaign-portal/namespace/entities/table-settings/specs';
import { EditCurrencyComponent } from './edit-currency/edit-currency.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Paging } from '@campaign-portal/namespace/common/rpc.params';
import { CurrenciesDialogComponent } from './dialog/dialog.component';

@Component({
	selector: 'app-currencies',
	templateUrl: './currencies.component.html',
	styleUrls: [
		'../../../../../node_modules/@campaign-portal/components-library/src/assets/templates/table-complex/complex-table.component.scss',
		'./currencies.component.scss'
	],
	providers: [
		AlarisTableStateService,
		{ provide: TABLE_STATE_SERVICE_INJECTOR, useExisting: AlarisTableStateService }
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class CurrenciesComponent extends AlarisComplexTableComponent<HlrCurrencies> {

	override rowActions: RowActionSimple<any>[] = [
		{
			icon: 'icon-edit',
			label: 'actions.edit',
			action: this.edit.bind(this),
			disabled: (currency: HlrCurrencies): boolean => {
				return !this.user.allowed(['currencies.edit']) || currency.isSystemCurrency
			}
		},
		{
			icon: 'icon-delete',
			label: 'actions.delete',
			action: this.delete.bind(this),
			highlight: true,
			separator: true,
			disabled: (currency: HlrCurrencies): boolean => {
				return !this.user.allowed(['currencies.edit']) || currency.isSystemCurrency
			}
		}
	];
	override readonly dblClickRowAction = this.edit;
	override readonly pageSizeOptions = [25, 50, 100, 200];
	override readonly paging: Paging = {
		Skip: this.activePage,
		Take: this.pageSize
	};

	constructor(
		public readonly user: UserService,
		dataService: CurrenciesService,
		public override readonly fieldsService: CurrenciesFieldsService,
		tableSettingsService: TableSettingsService,
		private readonly dialog: AlarisDialogService
	) {
		super(
			dataService,
			fieldsService,
			tableSettingsService,
			TableTypes.INTERNAL
		);
		this.state.filters()
			.set('name', { enabled: true })
			.set('charCode', { enabled: false })
			.set('currencySymbol', { enabled: true })
	}

	edit(currency?: HlrCurrencies): void {
		this.editPanel.open<EditCurrencyComponent, {
					client: HlrCurrencies
				}, boolean>(EditCurrencyComponent, EditPanelWidth.SM, { currency })
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((result) => {
				if ( result ) {
					this.load();
				}
			});		
	}

	delete(currency: HlrCurrencies): void {
		this.dialog.open<boolean>(CurrenciesDialogComponent, { autoFocus: false, data: { currency } })
			.closed
			.pipe(takeUntilDestroyed(this.destroyRef))
			.subscribe((result) => {
				if ( result ) {
					this.load();
				}
			});
	}

}
